import React from 'react';
import { motion } from 'framer-motion';

export default function Statement() {
  return (
    <section className="py-32 bg-maaich-green relative overflow-hidden flex items-center justify-center">
      {/* Dark overlay for contrast */}
      <div className="absolute inset-0 bg-black/80"></div>
      
      <div className="container mx-auto px-6 relative z-10 text-center">
        <motion.p 
          className="font-body text-maaich-lime font-semibold tracking-widest uppercase mb-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Nessuno te lo dice. Noi sì.
        </motion.p>
        
        <motion.h2 
          className="text-4xl md:text-6xl lg:text-8xl font-display uppercase italic leading-[1.1] text-white"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          PRIMA DI PAGARE <br className="hidden md:block"/> UNO SGOMBERO,<br/>
          <span className="text-maaich-lime border-b-4 border-maaich-lime">FAI VALUTARE</span> CIÒ CHE POSSIEDI.
        </motion.h2>
      </div>
    </section>
  );
}